import { IQueryString } from '../../../shared/models';
import { objToQueryString } from '../../../shared/models/utils';
import * as moment from 'moment';

export class NotificationsFilter implements IQueryString {
    private regions: number[];
    private page: number;
    private size: number;
    private start: string | moment.Moment;

    constructor(regions?: number[], page?: number,
                size?: number, start?: string | moment.Moment) {
        this.regions = regions;
        this.page = page || 1;
        this.size = size || 50;
        this.start = start || null;
    }

    toQueryString() {
        let payload = {
            page: this.page,
            size: this.size,
         };

        if (this.regions.length > 0) {
            payload['regions'] = this.regions;
        };

        if (this.start) {
            payload['date[start]'] = moment(this.start).format('MM/DD/YYYY');
        }
        return objToQueryString(payload);
    }
 }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/shared/models/notifications-filter.ts